import { generateApiPath } from "@routes/generatePath.ts";
import type { IExtractApiParams } from "@routes/types.ts";

const pathBase = `/surgeries/`;
const pathById = `${pathBase}:surgeryId/`;

type IPathByIdParams = IExtractApiParams<typeof pathById>;

export const surgeries = {
  getAll: () => generateApiPath(pathBase),
  post: () => generateApiPath(pathBase),
  put: (params: IPathByIdParams) => generateApiPath(pathById, params),
  delete: (params: IPathByIdParams) => generateApiPath(pathById, params),
};
